import stripAnsi from 'strip-ansi';
import isFullwidthCodePoint from 'is-fullwidth-code-point';

function getVisualWidth(char) {
  return (isFullwidthCodePoint(char.codePointAt(0)) ? 2 : 1) + (/[A-Z]/.test(char) ? 0.5 : 0);
}

export function displayLength(string) {
  let visualWidth = 0;

  const arr = [...stripAnsi(string).normalize()];
  for (let i = 0; i < arr.length; i++) {
    visualWidth += getVisualWidth(arr[i]);
  }

  return visualWidth;
}

export function sliceByDisplayLength(string, length) {
  let visualWidth = 0;

  const arr = [...stripAnsi(string).normalize()];
  let i = 0;
  while (i < arr.length && visualWidth < length) {
    visualWidth += getVisualWidth(arr[i]);
    i++;
  }
  if (visualWidth > length) i--;

  return arr.slice(0, i).join('');
}
